/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Logistics_Update_FailedInputs */

const en_orders_logistics_update_failed = /** @type {(inputs: Orders_Logistics_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update logistics details`)
};

const es_orders_logistics_update_failed = /** @type {(inputs: Orders_Logistics_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron actualizar los detalles de logistica`)
};

/**
* | output |
* | --- |
* | "Failed to update logistics details" |
*
* @param {Orders_Logistics_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_logistics_update_failed = /** @type {((inputs?: Orders_Logistics_Update_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Logistics_Update_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_logistics_update_failed(inputs)
	return es_orders_logistics_update_failed(inputs)
});